import AbstractRepository from "@/repositories/AbstractRepository";

export default class BudgetRepository extends AbstractRepository {
    protected static resource: string = "ptf-budget-budget";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
        "beginDate",
        "endDate",
        "amount",
        "amountIncludingTax",
        "owner.uuid",
        "consumedAmountAggregate",
    ];
}
